import React,{ Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { getMetodoAdmin,enviaMetodo } from '../actions'
import AdminMenu from '../components/admin_menu'
import Switch from "../components/switch";

class AdminMetodo extends Component{
	
	constructor(props) {
    	super(props)
    	this.state = {
            metodo:{
                nombre:"",
                desc:"",
                costo:0,
                estado:1
            },
        	loading : false,
            stats:["PENDIENTE","EN PROCESO","TERMINADO", "ENTREGADO"]
        }
        this.cambia = this.cambia.bind(this)
        this.envia = this.envia.bind(this);
        this.switchHandle = this.switchHandle.bind(this);
    }

    componentDidMount(){
        if(!this.props.usuario.user){
            this.props.history.push("/login")
        }
        if (this.props.match.params.id){
            console.log("MODIFICA")
            this.props.getMetodoAdmin(this.props.match.params.id)
        }else{
            console.log("AGREGA")
        }
        
    }

    componentDidUpdate(prevProps, prevState){
        if (this.props.contador > prevProps.contador) {
            this.props.history.push("/admin/metodos");
        }
        if (this.props.match.params.id && this.props.metodo!=null && this.props.metodo != this.state.metodo) {
          this.setState({ metodo: this.props.metodo });
        }
    }

    cambia = (e) => {
        var metodo = Object.assign(this.state.metodo);
        if (e.target.name === "costo") {
            metodo[e.target.name]= parseFloat(e.target.value)
        } else {
            metodo[e.target.name] = e.target.value
        }
        console.log(metodo)
        this.setState({ metodo });
    }
    envia = (e) => {
        this.props.enviaMetodo(this.state.metodo)
    }

    switchHandle = (campo,valor) => {
        console.log(this.state.metodo);
        var metodo = Object.assign(this.state.metodo);
        metodo[campo]=valor
        this.setState({ metodo });
    }

	render() {  
        if(this.state.loading){
            return <div>CARGANDO</div>
        }
    
        return <div className="container">
            <section className="row mb-5 sombraHead mt-3 clearfix">
              <div className="col-md-3 mb-3">
                <AdminMenu />
              </div>

              <div className="col-md-9 p-3">
                <div className="container">
                  <div>
                    <h1 className="display-4">Metodo</h1>
                  </div>
                  <div className="form-group">
                    <label>Nombre</label>
                    <input type="text" className="form-control" name="nombre" value={this.state.metodo.nombre} onChange={this.cambia} />
                  </div>
                  <div className="form-group">
                    <label>Descripcion</label>
                    <textarea className="form-control" name="desc" value={this.state.metodo.desc} onChange={this.cambia} />
                  </div>
                  <div className="form-row">
                    <div className="col-md-6 mb-3">
                      <label>Costo</label>
                      <input type="text" className="form-control" name="costo" value={this.state.metodo.costo} placeholder="Ingrese el costo" onChange={this.cambia} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>ESTADO</label>
                        <Switch switchAct={this.switchHandle} dato="estado" off_valor={0} on_valor = {1} off="NULO" on="ACTIVO" stat={this.state.metodo.estado}/>
                    </div>
                  </div>
                  <div className="form-row">
                    {this.props.match.params.id ? <button type="submit" className="btn btn-primary" onClick={this.envia}>
                        ACTUALIZAR
                      </button> : <button type="submit" className="btn btn-primary" onClick={this.envia}>
                        AGREGAR
                      </button>}
                  </div>
                </div>
              </div>
            </section>
          </div>;
    }
}

const mapStateToProps = state => {
	return {
        contador: state.pedidos.contador,
        metodo: state.pedidos.metodo,
        usuario: state.usuario
  	}
}

const mapDispatchToProps = dispatch => {
  return {
    getMetodoAdmin: (id) => {
      dispatch(getMetodoAdmin(id))
    },
    enviaMetodo: (data) => {
        dispatch(enviaMetodo(data))
    }
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminMetodo)




// WEBPACK FOOTER //
// ./src/containers/admin_metodo.js